module.exports = __webpack_public_path__ + "img/icon-contract.36195906.svg";